/**
 * Attendance Calendar master hub — tab definitions, roles, and URL helpers.
 */

export const ATTENDANCE_CALENDAR_MASTER_PATH = "/attendance/apply-calendar";

export const MASTER_TABS = [
  {
    id: "daily",
    label: "Monthly Attendance",
    shortLabel: "Monthly",
    description: "Select a month and employee to view and mark that employee’s monthly calendar",
    color: "teal",
    roles: ["admin", "hr"],
  },
  {
    id: "import",
    label: "Import Attendance",
    shortLabel: "Import",
    description: "Excel/CSV upload — quick rows or full templates with validation & audit",
    color: "indigo",
    roles: ["admin", "hr"],
  },
  {
    id: "apply",
    label: "Apply Calendar Marks",
    shortLabel: "Auto-mark",
    description: "Mark working days Present (P), plus holiday (H) and week-off (WO) from org policy",
    color: "purple",
    roles: ["admin", "hr"],
  },
  {
    id: "lock",
    label: "Lock Attendance",
    shortLabel: "Lock",
    description: "Freeze a date range so attendance, payroll, or finance cannot be edited until released",
    color: "rose",
    roles: ["admin"],
  },
];

const TAB_IDS = new Set(MASTER_TABS.map((t) => t.id));

export function attendanceCalendarTabUrl(tab, extraParams = {}) {
  const params = new URLSearchParams();
  if (tab && tab !== "daily") params.set("tab", tab);
  for (const [k, v] of Object.entries(extraParams)) {
    if (v != null && v !== "") params.set(k, v);
  }
  const qs = params.toString();
  return qs ? `${ATTENDANCE_CALENDAR_MASTER_PATH}?${qs}` : ATTENDANCE_CALENDAR_MASTER_PATH;
}

export function attendanceImportFocusUrl(extraParams = {}) {
  return attendanceCalendarTabUrl("import", extraParams);
}

export function attendanceLockFocusUrl(extraParams = {}) {
  return attendanceCalendarTabUrl("lock", extraParams);
}

export function filterMasterTabsByRole(role) {
  const r = String(role || "").toLowerCase();
  return MASTER_TABS.filter((t) =>
    t.roles.some((x) => String(x).toLowerCase() === r)
  );
}

export function resolveMasterTab(tabId, allowedTabs) {
  if (tabId === "bulk") tabId = "import";
  if (tabId === "freeze") tabId = "lock";
  if (tabId && TAB_IDS.has(tabId)) {
    const found = allowedTabs.find((t) => t.id === tabId);
    if (found) return found.id;
  }
  return allowedTabs[0]?.id || "daily";
}

export function getMasterTabMeta(tabId) {
  return MASTER_TABS.find((t) => t.id === tabId) || MASTER_TABS[0];
}
